import React from 'react'
import clsx from 'clsx'
import {HorizontalTabs} from './HorizontalTabs/index.ts'
import {DropdownTabs} from './DropdownTabs/index.ts'
import styles from './TableTabs.module.scss'

export interface TableTabsBaseProps {
    className?: string
    activeTabId: string
    tabs: {
        id: string
        label: string
    }[]
    onTabChange: (tabId: string) => void
    size: 'sm' | 'md'
}

export interface TableTabsProps extends TableTabsBaseProps {
    switchToDropdownOnMediumScreens?: boolean
}

export const TableTabs = ({
    switchToDropdownOnMediumScreens = false,
    ...props
}: TableTabsProps) => {
    if(!switchToDropdownOnMediumScreens) return <HorizontalTabs {...props} />

    return <>
        <HorizontalTabs {...props} className={clsx(props.className, styles.showOnMediumScreensAndAbove)} />
        <DropdownTabs {...props} className={clsx(props.className, styles.hideOnMediumScreensAndAbove)} />
    </>
}
